import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAcGbIoBCaSCUZhoqcEf4LXHlJZCu7k93I",
  projectId: "connect-social-project",
  storageBucket: "connect-social-project.appspot.com",
  appId: "1:376521021326:web:da937148b2599ed221b6df",
};

// Main app: Firestore + Storage (project connect-social-project).
const app = initializeApp(firebaseConfig, "cs");
export const storage = getStorage(app);
export const db = getFirestore(app);

// Google Analytics lives on the separate "arthereum-wallet" Firebase app —
// its measurementId (G-F6WE4C3PE1) is the property the owner's dashboards read.
// Loaded lazily after startup so it adds nothing to the first paint, and only
// in production so localhost testing doesn't pollute the stats.
const analyticsConfig = {
  apiKey: "AIzaSyArO6n1EnvQ0hAAfXPFJVn0PcbZHbpUjY4",
  authDomain: "arthereum-wallet.firebaseapp.com",
  projectId: "arthereum-wallet",
  storageBucket: "arthereum-wallet.firebasestorage.app",
  messagingSenderId: "375858750091",
  appId: "1:375858750091:web:a741ebed7ea2a80b696a8e",
  measurementId: "G-F6WE4C3PE1",
};

if (typeof window !== "undefined" && process.env.NODE_ENV === "production") {
  import("firebase/analytics")
    .then(async ({ getAnalytics, isSupported }) => {
      if (await isSupported()) {
        getAnalytics(initializeApp(analyticsConfig));
      }
    })
    .catch(() => {
      /* analytics must never break the app */
    });
}
